(function () {
  function dispatch(el, eventName) {
    el.dispatchEvent(new Event(eventName, { bubbles: true }));
  }

  function syncText(input, value) {
    input.value = value;
    dispatch(input, 'input');
    dispatch(input, 'change');
  }

  function setCheckbox(boldCheckbox, checked) {
    if (boldCheckbox.checked !== checked) {
      boldCheckbox.click();
    }
  }

  function norm(s) {
    return (s || '').trim().toLowerCase();
  }

  function findBoldOption(root, title) {
    const target = norm(title);
    if (!target) return null;
    const opts = root.querySelectorAll('.bold_option');
    for (const opt of opts) {
      const titleEl = opt.querySelector('.bold_option_title');
      if (titleEl && norm(titleEl.textContent) === target) return opt;
    }
    return null;
  }

  function populateMeta(card, boldOption) {
    const titleEl = boldOption.querySelector('.bold_option_title');
    const priceEl = boldOption.querySelector('.bold_option_value_price');

    const titleSlot = card.querySelector('[data-bold-shadow-title]');
    const priceSlot = card.querySelector('[data-bold-shadow-price]');

    if (titleSlot && titleEl && !card.hasAttribute('data-bold-shadow-keep-title')) {
      titleSlot.textContent = titleEl.textContent.trim();
    }
    if (priceSlot) {
      priceSlot.textContent = priceEl ? priceEl.textContent.trim() : '';
    }
  }

  function bindMonogramCard(card, checkboxOption, textOption) {
    const boldCheckbox = checkboxOption.querySelector('input[type="checkbox"]');
    const boldText = textOption ? textOption.querySelector('input[type="text"]') : null;
    if (!boldCheckbox || !boldText) return false;

    const shadowText = card.querySelector('.tr-bold-shadow__monogram-input');
    const shadowClear = card.querySelector('.tr-bold-shadow__clear');
    if (!shadowText || !shadowClear) return false;

    const newText = shadowText.cloneNode(true);
    shadowText.replaceWith(newText);
    const newClear = shadowClear.cloneNode(true);
    shadowClear.replaceWith(newClear);

    newText.value = boldText.value;
    newClear.classList.toggle('is-visible', boldText.value.length > 0);

    newText.addEventListener('input', function () {
      const val = this.value.toUpperCase();
      this.value = val;
      newClear.classList.toggle('is-visible', val.length > 0);
      syncText(boldText, val);
      setCheckbox(boldCheckbox, val.length > 0);
    });

    newClear.addEventListener('click', function () {
      newText.value = '';
      newClear.classList.remove('is-visible');
      syncText(boldText, '');
      setCheckbox(boldCheckbox, false);
      newText.focus();
    });

    return true;
  }

  function bindAddonCard(card, boldOption) {
    const boldCheckbox = boldOption.querySelector('.bold_option_checkbox input[type="checkbox"]');
    if (!boldCheckbox) return false;

    const shadowCb = card.querySelector('.tr-bold-shadow__addon-checkbox');
    if (!shadowCb) return false;

    const newCb = shadowCb.cloneNode(true);
    shadowCb.replaceWith(newCb);

    newCb.checked = boldCheckbox.checked;
    newCb.addEventListener('change', function () {
      setCheckbox(boldCheckbox, this.checked);
    });

    return true;
  }

  function bindCard(card, boldOptionsRoot) {
    const title = card.dataset.boldTitle;
    const boldOption = findBoldOption(boldOptionsRoot, title);
    if (!boldOption) {
      card.hidden = true;
      return false;
    }

    const isMonogram = !!card.querySelector('.tr-bold-shadow__monogram-input');
    let ok;
    if (isMonogram) {
      const textOption = findBoldOption(boldOptionsRoot, card.dataset.boldTextTitle);
      ok = bindMonogramCard(card, boldOption, textOption);
    } else {
      ok = bindAddonCard(card, boldOption);
    }
    if (!ok) {
      card.hidden = true;
      return false;
    }

    populateMeta(card, boldOption);
    card.hidden = false;
    return true;
  }

  function bindAll(boldOptions, shadow) {
    const cards = shadow.querySelectorAll('.tr-bold-shadow__card');
    let anyBound = false;
    cards.forEach(function (card) {
      if (bindCard(card, boldOptions)) anyBound = true;
    });

    shadow.dataset.boldShadowState = anyBound ? 'ready' : 'empty';
  }

  function init() {
    const boldOptions = document.querySelector('.bold_options');
    const shadow = document.querySelector('#tr-bold-shadow');

    if (!boldOptions || !shadow) return;

    boldOptions.style.cssText = 'display:none!important';

    const observer = new MutationObserver(function () {
      if (boldOptions.querySelector('.bold_option_set')) {
        bindAll(boldOptions, shadow);
      }
    });

    observer.observe(boldOptions, { childList: true, subtree: true });

    if (boldOptions.querySelector('.bold_option_set')) {
      bindAll(boldOptions, shadow);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
